import { Component } from '@angular/core';

@Component({
  selector: 'reinstate-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'reinstate';
}
